import { alpha, Theme } from '@mui/material/styles'

// Light blue fill shared by every tag chip, so tags read as one thing
// across the app.
export const tagChipSx = {
  bgcolor: (t: Theme) => alpha(t.palette.info.main, 0.12),
  color: (t: Theme) => t.palette.info.dark,
  border: '1px solid',
  borderColor: (t: Theme) => alpha(t.palette.info.main, 0.3),
  '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible': {
    bgcolor: (t: Theme) => alpha(t.palette.info.main, 0.2),
  },
  '& .MuiChip-icon, & .MuiChip-deleteIcon': {
    color: (t: Theme) => alpha(t.palette.info.dark, 0.7),
  },
  '& .MuiChip-deleteIcon:hover': {
    color: (t: Theme) => t.palette.info.dark,
  },
} as const
